import { render, staticRenderFns } from "./TelegraphicTransferDetail.vue?vue&type=template&id=7d368db0&scoped=true"
import script from "./TelegraphicTransferDetail.vue?vue&type=script&lang=js"
export * from "./TelegraphicTransferDetail.vue?vue&type=script&lang=js"
import style0 from "./TelegraphicTransferDetail.vue?vue&type=style&index=0&id=7d368db0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d368db0",
  null
  
)

export default component.exports